"use client";
import { usePathname, useSearchParams } from "next/navigation";
import { useRouter } from "next/navigation";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { useState } from "react";
import { useLocale } from "next-intl";

export default function ToggleLocale() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);
  const handleLanguageToggle = (newLocale) => {
    setIsOpen(true);
    const path = pathname.split("/").slice(2).join("/");

    const queryString = searchParams
      ? `?${new URLSearchParams(searchParams).toString()}`
      : "";

    router.push(`/${newLocale}/${path}${queryString}`);
    setIsOpen(false);
  };

  return (
    <Select
      onOpenChange={(open) => setIsOpen(open)}
      onValueChange={(val) => handleLanguageToggle(val)}
      className="w-full  "
    >
      <SelectTrigger
        className=" h-10 rounded-3xl  justify-center gap-2  border-none bg-secondary px-4 flex w-[113px] items-center"
        variant="secondary"
        aria-label="choose option"
        isOpen={isOpen}
      >
        {locale == "en" ? "English" : "Русский"}
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={"en"}>
          <p>English</p>
        </SelectItem>
        <SelectItem value={"ru"}>
          <p>Русский</p>
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
